import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import OrangeLinkWithArrow from "./OrangeLinkWithArrow";
import SubscribeForm from "./SubscribeForm";
import WhiteLinkWithX from "./WhiteLinkWithX";
import CloseButton from './CloseButton';
import {closeSubscribePopup} from "../redux/actions";
import {store} from '../index';


class SubscribePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
    };
  }

  close = () => {
    store.dispatch(closeSubscribePopup());
    window.suppressSubscribePopup = true;
  };

  componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      if (this.props.open) {
        window.analytics.track("Newsletter - Subscribe Popup Opened");
      } else {
        window.analytics.track("Newsletter - Closed Subscribe Popup");
      }
    }
  }

  clickedFirstSubscribe = () => {
    window.analytics.track("Newsletter - Clicked First Subscribe");
    this.setState({step: 2});
  };

  clickedSecondSubscribe = (values) => {
    return fetch("https://hooks.zapier.com/hooks/catch/2488913/wcxscv/", {
      method: 'POST',
      body: JSON.stringify({
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
      }),
    }).then(response => {
      window.analytics.track('Newsletter - Subscribed', {location: 'Popup'});
      window.analytics.identify({
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
      });

      window.localStorage.setItem('subscribed', 'true');
      window.suppressSubscribePopup = true;

      this.setState({step: 3});
    });
  };

  content = () => {
    const {classes} = this.props;

    if (this.state.step === 1) {
      return (
        <div className={classes.content}>
          <header className={classes.header}>
            <div className={classes.title}>
              See the inner workings:
            </div>
            <div className={classes.message}>
              Get priority access to new content or events.
            </div>
            <CloseButton className={classes.closeButton} onClick={this.close}/>
          </header>
          <div className={classes.action}>
            <OrangeLinkWithArrow onClick={this.clickedFirstSubscribe}>Subscribe</OrangeLinkWithArrow>
          </div>
        </div>
      )
    } else if (this.state.step === 2) {
      return (
        <SubscribeForm onSubmit={this.clickedSecondSubscribe} closePopup={this.close}/>
      )
    } else {
      return (
        <div className={classes.thankYouContent}>
          <div className={classes.thankYouTitle}>Thank you!</div>
          <div className={classes.message}>Welcome to the Gridhaus family. We’ll be keeping you in the loop.</div>
          <WhiteLinkWithX className={classes.closeLink} onClick={this.close}>Close</WhiteLinkWithX>
          <CloseButton className={classes.closeButton} onClick={this.close}/>
        </div>
      )
    }
  };

  render() {
    const {classes} = this.props;

    return (
      <div className={`${classes.popup} ${this.props.open && classes.open}`}>
        {this.content()}
      </div>
    )
  }
}


export default withStyles((theme) => ({
  popup: {
    position: 'fixed',
    zIndex: '10',
    bottom: '6px',
    left: '50%',
    transform: 'translate(-50%, 100%)',
    opacity: 0,
    width: '100%',
    maxWidth: 648,
    boxShadow: `0 3px 6px rgba(0,0,0,0.16)`,
    transition: 'all 500ms ease-out',
  },
  open: {
    transform: 'translate(-50%, 0)',
    opacity: 1,
  },
  content: {
    [theme.breakpoints.up(1024)]: {
      display: 'flex',
    }
  },
  header: {
    background: theme.palette.primary.main,
    padding: theme.spacing.unit * 2,
    flexGrow: 1,
    position: 'relative',
  },
  action: {
    background: theme.palette.secondary.dark,
    padding: theme.spacing.unit * 2,
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    color: theme.palette.secondary.dark,
    ...theme.typography.hg14bu(theme),
    marginBottom: theme.spacing.unit,
  },
  message: {
    color: theme.palette.secondary.dark,
    ...theme.typography.hg18r(theme),
  },
  thankYouContent: {
    background: theme.palette.primary.main,
    padding: theme.spacing.unit * 2,
    position: 'relative',
  },
  thankYouTitle: {
    color: theme.palette.secondary.dark,
    ...theme.typography.hg14bu(theme),
    marginBottom: theme.spacing.unit * 2,
  },
  closeLink: {
    marginTop: theme.spacing.unit * 2,
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing.unit * 2,
    right: theme.spacing.unit * 2,
  },
}))(SubscribePopup);


// WEBPACK FOOTER //
// ./src/parts/SubscribePopup.js